import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class SortBySelectController implements angular.IComponentController {
    isDisabled: boolean;
    model: string[];
    propertyName: string;

    static $inject = [];
}

export const wtSortBySelect: ComponentDefinition = {
    componentId: 'wtSortBySelect',
    controller: SortBySelectController,
    template: require('./sortBySelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<',
        model: '=',
        propertyName: '<'
    }
};
